// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

let defaultSdkConfigValue_payment_methods = [];

let defaultSdkConfigValue = {
  raw_configs: undefined,
  payment_methods: defaultSdkConfigValue_payment_methods,
  account_config: undefined,
  context_used: undefined
};

function getVaultingAction(config) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(Core__Option.flatMap(config, c => c.account_config), ac => ac.profile), p => p.vaulting_action), "Skip");
}

export {
  defaultSdkConfigValue,
  getVaultingAction,
}
/* No side effect */
